import { Button, Container, Grid, Message, Text } from "basis";
import { FormActions } from "components/FormActions/FormActions";
import { deleteDirectDebit } from "library/api";
import { useMutation } from "react-query";
import { CreditCard } from "../CreditCard/CreditCard";
import {
  BACK_CLICKED,
  CANCEL_DIRECT_DEBIT_FAILED,
  CANCEL_DIRECT_DEBIT_SUCCEEDED,
} from "./constants";

export const DirectDebitCancel = ({ state, dispatch }) => {
  const { cardName, cardEndsWith, cardToken } = state.toAccount.data;
  const cancelDirectDebitMutation = useMutation(deleteDirectDebit, {
    onSuccess: () => {
      dispatch({
        type: CANCEL_DIRECT_DEBIT_SUCCEEDED,
      });
    },
    onError: () => {
      dispatch({
        type: CANCEL_DIRECT_DEBIT_FAILED,
      });
    },
  });

  return (
    <Grid rowsGap="6" rowsGap-sm="8">
      <Container bg="grey.t05" padding="4">
        <CreditCard cardName={cardName} cardEndsWith={cardEndsWith} />
      </Container>
      <Text as="h3" textStyle="heading5" textStyle-sm="heading4">
        Do you wish to cancel your existing direct debit?
      </Text>
      <Text>
        We’ll stop debiting your selected monthly payment amount from your
        nominated bank account.
        <br />
        <br />
        Please continue to keep your {cardName} account up to date to ensure
        that you do not miss a payment and risk any late fees.
      </Text>
      <Message severity="info-or-minor" bg="secondary.lightBlue.t25">
        Account holder’s bank account details are removed and cannot be
        reinstated without the account holder providing these details again
        through a new direct debit request.
      </Message>
      <Container width="100%" width-sm="400">
        <FormActions>
          <FormActions.Primary>
            <Button
              width="100%"
              loading={cancelDirectDebitMutation.isLoading}
              onClick={() => {
                cancelDirectDebitMutation.mutate({
                  token: cardToken,
                });
              }}
            >
              Cancel direct debit
            </Button>
          </FormActions.Primary>
          <FormActions.Secondary>
            <Button
              variant="secondary"
              width="100%"
              onClick={() => {
                dispatch({
                  type: BACK_CLICKED,
                });
              }}
            >
              Back
            </Button>
          </FormActions.Secondary>
        </FormActions>
      </Container>
    </Grid>
  );
};
